module.exports = __webpack_public_path__ + "static/media/other_documents_active_es.9890fd70.svg";